import { ICorporateValueResponse } from "gql/CorporateValues/queries";
import { create } from "zustand";

interface CorporateState {
  loadingCorporate: boolean;
  errorCorporate: Error | null;
  dataCorporate: ICorporateValueResponse | null;
  setLoadingCorporate: (loading: boolean) => void;
  setErrorCorporate: (error: Error | null) => void;
  setDataCorporate: (data: ICorporateValueResponse | null) => void;
}

export const useCorporateStore = create<CorporateState>((set) => ({
  loadingCorporate: false,
  errorCorporate: null,
  dataCorporate: null,
  setLoadingCorporate: (loading) => set({ loadingCorporate: loading }),
  setErrorCorporate: (error) => set({ errorCorporate: error }),
  setDataCorporate: (data) => set({ dataCorporate: data }),
}));
